/* src/components/FacturasView.jsx */
import React, { useState, useEffect } from "react";
import {
  collection,
  onSnapshot,
  doc,
  updateDoc
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import { useFunctionsPrevia } from "../hooks/useFunctionsPrevia"; 

export default function FacturasView({ pedidoId }) {
  const [facturasAsociadas, setFacturasAsociadas] = useState([]);
  const [facturasMap, setFacturasMap] = useState({});
  const { formatDate } = useFunctionsPrevia();

  // 1) Mapa de todas las facturasEmitidas (para leer y togglear estado)
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, "facturasEmitidas"),
      (snap) => {
        const m = {};
        snap.docs.forEach((d) => {
          m[d.id] = d.data();
        });
        setFacturasMap(m);
      }
    );
    return () => unsub();
  }, []);

  // 2) Facturas ya asociadas a este pedido
  useEffect(() => {
    if (!pedidoId) return;
    const ref = collection(db, "pedidos", pedidoId, "facturas");
    const unsub = onSnapshot(ref, (snap) => {
      setFacturasAsociadas(
        snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((f) => Number(f.monto) > 0)
      );
    });
    return () => unsub();
  }, [pedidoId]);

  const formatNumber = (value) =>
    Number(value).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  // 3) Función para cambiar el estado en Firestore
  const toggleEstado = async (idFactura) => {
    const current = facturasMap[idFactura]?.estado || "Pendiente";
    let next;
    if (current === "Pendiente") next = "Pagada";
    else if (current === "Pagada") next = "Cancelado";
    else if (current === "Cancelado") next = "Pendiente";
    else next = "Pendiente";

    try {
      const ref = doc(db, "facturasEmitidas", idFactura);
      await updateDoc(ref, { estado: next });
      // no hace falta setState manual: el onSnapshot recargará facturasMap
    } catch (err) {
      console.error("Error actualizando estado:", err);
    }
  };

  return (
    <div style={{ padding: 30 }}>
      <h3>Búsquedas asociadas:</h3>

      {facturasAsociadas.length === 0 ? (
        <p style={{ textAlign: "center", opacity: 0.6 }}>
          Por favor, espere un momento
        </p>
      ) : (
        <div style={{ maxHeight: 350, overflowY: "auto" }}>
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Folio</th>
                <th>Fecha emisión</th>
                <th>Razón social</th>
                <th>RFC</th>
                <th>Tipo</th>
                <th className="text-end">Monto</th>
                <th>Estado</th>
                <th>Fecha asoc.</th>
              </tr>
            </thead>
            <tbody>
              {facturasAsociadas.map((f) => {
                const orig = facturasMap[f.idFactura] || {};
                const estadoText = orig.estado || "Pendiente";
                const estadoCls =
                  estadoText === "Pagada"
                    ? "pagada"
                    : estadoText === "Cancelado"
                    ? "cancelado"
                    : "pendiente";
                return (
                  <tr key={f.id}>
                    <td>{f.folio}</td>
                    <td>
                      {orig.Fecha
                        ? new Date(orig.Fecha).toLocaleDateString("es-ES", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : ""}
                    </td>
                    <td>{orig.receptor_Nombre}</td>
                    <td>{orig.receptor_Rfc}</td>
                    <td>
                      {orig.TipoDeComprobante === "I"
                        ? "Ingreso"
                        : orig.TipoDeComprobante === "E"
                        ? "Egreso"
                        : orig.TipoDeComprobante === "P"
                        ? "Pago"
                        : orig.TipoDeComprobante}
                    </td>
                    <td className="text-end">${formatNumber(f.monto)}</td>
                    <td>
                      <div
                        className={`status ${estadoCls}`}
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleEstado(f.idFactura)}
                      >
                        {estadoText}
                      </div>
                    </td>
                    <td>{formatDate(f.asociadoEn)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
